import { render, staticRenderFns } from "./QcTestUpdateFormulationPopUp.vue?vue&type=template&id=b647fd56&scoped=true&"
import script from "./QcTestUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./QcTestUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QcTestUpdateFormulationPopUp.vue?vue&type=style&index=0&id=b647fd56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b647fd56",
  null
  
)

export default component.exports